import { Link } from "react-router-dom";
import { mdiMenu } from "@mdi/js";
import Icon from "@mdi/react";
import { Button, Flex, Grid } from "antd";
import { observer } from "mobx-react-lite";

import { sendCounterEvent } from "../../utils/counterService";
import { CreateWebgisButton } from "./headerButtons/CreateWebgisButton";
import { DevButton } from "./headerButtons/DevButton";
import { DocsButton } from "./headerButtons/DocsButton";
import { PlanBadge } from "./headerButtons/PlanBadge";
import { ServicesMenu } from "./headerButtons/ServicesMenu";
import { Logo } from "./Logo";
import { LogoSmall } from "./LogoSmall";
import { UserMenu } from "./UserMenu";

import "./AppHeader.css";

const { useBreakpoint } = Grid;

interface AppHeaderProps {
  onMenuClick?: () => void;
  minimal?: boolean;
}

const AppHeader = observer(function AppHeader({
  onMenuClick,
  minimal,
}: AppHeaderProps) {
  const screens = useBreakpoint();
  return (
    <header className="app-header">
      <div className="app-header__inner">
        <div className="app-header__logo">
          {!screens.lg ? (
            <Flex align="center" justify="space-between" gap={8}>
              <Button
                type="text"
                className="app-header__menu-btn"
                style={{ backgroundColor: "transparent" }}
                icon={<Icon color="#aec8e0" path={mdiMenu} size={1} />}
                onClick={() => {
                  sendCounterEvent("header_menu");
                  onMenuClick?.();
                }}
              />
              <Link to="/" className="nolink">
                <LogoSmall />
              </Link>
            </Flex>
          ) : (
            <Link to="/" className="nolink">
              <Logo />
            </Link>
          )}
        </div>
        <div className="app-header__title">
          <Link to="/" className="nolink app-header__title-link">
            <span className="app-header__title-prefix">NextGIS </span>
            ID
          </Link>
        </div>
        <div className="app-header__right">
          {!minimal && <CreateWebgisButton />}
          <DevButton />
          {!minimal && <PlanBadge />}
          {!minimal && <DocsButton />}
          {!minimal && <ServicesMenu />}
          <UserMenu />
        </div>
      </div>
    </header>
  );
});

export default AppHeader;
